import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/payments/stripe/return/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/settings/organization/payment-options/stripe/return',
      replace: true,
    })
  },
})
